module.exports = __webpack_public_path__ + "img/wuye3.2c350757.jpg";